import { customerTenant } from '@env/environment';

type TenantKeys = (typeof customerTenant)[keyof typeof customerTenant] | 'DEFAULT';


function normalizeTenantKey(value: string): string {
    return value.split('_')[0];
}

export const tenantImagesMap: Record<TenantKeys, Record<string, string>> = {
    [customerTenant.FIB]: {},
    [customerTenant.INC]: {
        logo: '/assets/inc-neo/logo.svg',
        welcome_logo: '/assets/inc-neo/logo.svg',
        sidenav_logo: '/assets/inc-neo/sidenav-logo.svg',
        welcome_screen_bg: '/assets/inc-neo/welcome-screen-bg.svg',
        login_bg: '',
        favicon: '/assets/inc-neo/favicon.ico',
    },
    [customerTenant.NASS]: {
        logo: '/assets/tenant37/logo.png',
        welcome_logo: '/assets/tenant37/welcome-screen-logo.png',
        sidenav_logo: '/assets/tenant37/logo.png',
        welcome_screen_bg: '/assets/tenant37/welcome-screen-bg.png',
        login_bg: '/assets/tenant37/login-right-background-cover.mp4',
        favicon: '/assets/tenant37/favicon.ico',
    },
    [normalizeTenantKey(customerTenant.IC)]: {
        logo: '/assets/tenant10/logo.png',
        welcome_logo: '/assets/tenant10/welcome_logo.svg',
        sidenav_logo: '/assets/tenant10/side-nav-logo.png',
        welcome_screen_bg: '/assets/tenant10/welcome_logo_bg.svg',
        login_bg: '/assets/tenant10/login-signup-logo.png',
        favicon: '/assets/tenant10/favicon.ico',
    },
    [normalizeTenantKey(customerTenant.BSF)]: {
        logo: '/assets/tenant1/logo.png',
        welcome_logo: '/assets/tenant1/logo.png',
        sidenav_logo: '/assets/tenant1/logo.png',
        welcome_screen_bg: 'null',
        login_bg: '/assets/tenant1/login-signup-logo.jpg',
        favicon: '/assets/tenant1/favicon.png',
        primary_color: '#005A6C',
        secondary_color: '#75CDD9',
        tertiary_color: '#EFFBFD',
        side_bar_bg: '#005A6C',
    },
    [normalizeTenantKey(customerTenant.RIYAD)]: {
        logo: '/assets/tenant12/riyad-logo.png',
        welcome_logo: '/assets/tenant12/riyad-logo.png',
        sidenav_logo: '/assets/tenant12/riyad-log.png',
        welcome_screen_bg: 'null',
        login_bg: '/assets/welcome-screen/login-signup-logo.png',
        favicon: '/assets/tenant12/favicon.png',
        primary_color: '#2D124D',
        secondary_color: '#2D124D',
        tertiary_color: '#2D124D',
        side_bar_bg: '#2D124D',
    },
    DEFAULT: {
        logo: '/assets/nymcard-logo.svg',
        welcome_logo: '/assets/welcome-screen/welcome-screen-nym-logo.svg',
        sidenav_logo: '/assets/logo-white.png',
        welcome_screen_bg: '/assets/welcome-screen/welcome-screen-bg.svg',
        login_bg: '/assets/welcome-screen/login-signup-logo.png',
        favicon: '/favicon.ico',
        side_bar_bg: 'linear-gradient(179.18deg, #26a0bd -80.01%, #020e3d 24.57%, #020e3d 74.32%, #35dbf1 290.61%)',
    },
};


export function applyTenantTheme(tenantKey: string): void {
  const normalizeTenant = normalizeTenantKey(tenantKey)
  const tenant: any = tenantImagesMap[normalizeTenant] || tenantImagesMap['DEFAULT'];
  const defaultSideBg = tenantImagesMap['DEFAULT']['side_bar_bg']

  const root = document.documentElement;
  root.style.setProperty('--primary-color', tenant.primary_color || '#00a6fb');
  root.style.setProperty('--secondary-color', tenant.secondary_color || '#f2f2f2');
  root.style.setProperty('--side-bar-bg', tenant.side_bar_bg || defaultSideBg);
}